import React from 'react'
import Icon from 'react-icon-base'

export default (props) => {
  return (
    <Icon viewBox='0 0 16 16' {...props}>
      <title id='User'>{props.title || 'User'}</title>
      <g>
        <title>User</title>
        <path d='M 8 0 C 3.591 0 0 3.589 0 8 C 0 12.41 3.59 16 8 16 C 12.41 16 16 12.411 16 8 C 16 3.591 12.41 0 8 0 M 12.786 12.624 C 12.768 12.624 12.732 12.607 12.714 12.607 C 11.25 12.25 10.054 11.697 10.054 11.697 C 9.91 11.5 9.821 11.161 9.803 10.929 C 10.125 10.482 10.304 9.964 10.375 9.5 C 10.41 9.518 10.446 9.536 10.481 9.536 C 10.624 9.536 10.803 9.357 10.999 8.643 C 11.213 7.911 11.089 7.66 10.91 7.589 C 11.499 4.767 10.16 4.678 10.16 4.678 C 10.16 4.678 9.965 4.286 9.429 3.999 C 9.126 3.821 8.715 3.659 8.197 3.659 C 8.107 3.659 8.036 3.659 7.946 3.678 C 7.732 3.695 7.535 3.73 7.356 3.785 C 7.124 3.874 6.892 3.981 6.696 4.124 C 6.446 4.285 6.232 4.463 6.017 4.695 C 5.695 5.034 5.41 5.444 5.286 5.98 C 5.161 6.426 5.178 6.927 5.339 7.427 L 5.286 7.427 C 5.053 7.427 4.821 7.605 5.071 8.498 C 5.267 9.194 5.446 9.391 5.59 9.391 C 5.661 9.89 5.84 10.479 6.214 10.961 C 6.179 11.158 6.125 11.443 6.001 11.641 C 6.001 11.641 4.751 12.248 3.287 12.606 C 3.269 12.606 3.233 12.624 3.215 12.624 C 2.054 11.427 1.34 9.801 1.34 7.998 C 1.34 4.32 4.322 1.337 8.001 1.337 C 11.679 1.337 14.662 4.319 14.662 7.998 C 14.661 9.803 13.947 11.428 12.786 12.624' />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/user.js